import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ActionStateModel } from 'src/Models/ActionStateModel';
import { FilterModel } from 'src/Models/filterModel';
import { TracAlertsModel } from 'src/Models/TracAlertsModel';
import { ActionItemService } from 'src/Services/actionitem.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-action-item-updates',
  templateUrl: './action-item-updates.component.html',
  styleUrls: ['./action-item-updates.component.css']
})
export class ActionItemUpdatesComponent implements OnInit {
  tokenKey: string = '';
  isloading: boolean = false;
  filteModel = new FilterModel();
  TracAlertsModel: TracAlertsModel[];
  TracAlertsExportModel: TracAlertsModel[];
  totalRecordCount: number = -1;
  isAscending: boolean;
  actionId:number=0;

  upDownAlertDateCSS: string = '';
  upDownStateNameCSS: string = '';
  upDownSubjectCSS: string = '';
  upDownStatusCSS: string = '';
  upDownCreatedDateCSS: string = '';
  upDownModifiedDateCSS: string = '';
  Id: number = 0;
  IsSendEmail:boolean
  actionStateList: ActionStateModel[];

  constructor(private readonly toastr: ToastrService, 
    private readonly router: Router, 
    private readonly actionItemServices: ActionItemService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Trac-It Alerts');
  }

  ngOnInit() {
    this.filteModel.pageNumber = '1';
    this.filteModel.pageSize = '10';
    this.filteModel.keywordFilter = '';
    this.filteModel.orderBy = 'ActionId ASC';
    this.filteModel.actionId=0;
    this.filteModel.userID = '0';
    this.GetTracUpdateFindByPages();
  }

  GetTracUpdateFindByPages() {
    this.isloading = true;
    this.TracAlertsModel=[];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport=false;
    this.actionItemServices.GetTracUpdateFindByPagesV2(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.isloading = false;
        this.TracAlertsModel = data['tracItAlertList'];
        if (this.TracAlertsModel != null) {
          if (this.TracAlertsModel.length > 0) {
            this.totalRecordCount = +this.TracAlertsModel[0].totalRowCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      }
      else {
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  GetModelActionState(actionId: any) {
    this.actionStateList = [];
    this.actionItemServices.GetActionStateByActionId(this.tokenKey, actionId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.actionStateList = data['actionState'];
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  keywordFilters($event) {
    this.filteModel.keywordFilter = $event.target.value;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filteModel.keywordFilter = $event.target.value;
    }
    else { this.filteModel.keywordFilter = ''; }

    this.filteModel.pageNumber = '1';
    this.GetTracUpdateFindByPages();
  }

  sort(sortBy: any) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.filteModel.orderBy = sortBy + ' DESC';
      this.setDescCSS(sortBy);
    }
    else {
      this.isAscending = false;
      this.filteModel.orderBy = sortBy;

      this.setAscCSS(sortBy);
    }
    this.filteModel.pageNumber = '1';
    this.GetTracUpdateFindByPages();
  }

  setDescCSS(sortBy) {
    if (sortBy === "deadlineDate") {
      this.upDownAlertDateCSS = 'fa fa-arrow-down';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS='';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "subject") {
      this.upDownAlertDateCSS = '';
      this.upDownStateNameCSS='';
      this.upDownSubjectCSS = 'fa fa-arrow-down';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "StateName") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS = 'fa fa-arrow-down';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "createdDate") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS = '';
      this.upDownCreatedDateCSS='fa fa-arrow-down';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "modifiedDate") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS = '';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='fa fa-arrow-down';
    }
  }

  setAscCSS(sortBy) {
    if (sortBy === "deadlineDate") {
      this.upDownAlertDateCSS = 'fa fa-arrow-up';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS ='';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "subject") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = 'fa fa-arrow-up';
      this.upDownStateNameCSS ='';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "StateName") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS = 'fa fa-arrow-up';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "createdDate") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS = '';
      this.upDownCreatedDateCSS='fa fa-arrow-up';
      this.upDownModifiedDateCSS='';
    }
    else if (sortBy === "modifiedDate") {
      this.upDownAlertDateCSS = '';
      this.upDownSubjectCSS = '';
      this.upDownStateNameCSS = '';
      this.upDownCreatedDateCSS='';
      this.upDownModifiedDateCSS='fa fa-arrow-up';
    }
  }

  pageChanged($event) {
    this.filteModel.pageNumber = parseInt($event.page).toString();
    this.GetTracUpdateFindByPages();
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  redirectToEditView(actionId:any) {
    this.router.navigate(['/admin/trac-it/Trac-itAlerts/user/' + actionId]);
  }

  SetCancelMailId(actionId: any) {
    this.Id = actionId;
  }

  CancelMail()
  {
    this.actionItemServices.notsentmail(this.tokenKey, this.Id).subscribe(
      data => {
      if (data['status'] == 'Success') {
        this.showMessage('', 'Success', 'success');
        this.GetTracUpdateFindByPages();
      }
      else
        this.showMessage(data['status'], 'Error', 'error');
    },
    error => {
      this.showMessage(error, 'Error', 'error');
    }
  );
  }

  ExportTracItUpdates() {
    this.isloading = true;
    this.TracAlertsExportModel=[];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport=true;
    this.actionItemServices.GetTracUpdateFindByPagesV2(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.TracAlertsExportModel = data['tracItAlertList'];
        if (this.TracAlertsExportModel != null) {
          if (this.TracAlertsExportModel.length > 0) {
            setTimeout(() => {
              this.DownloadTracItUpdates();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else{
          this.isloading = false;
            this.toastr.error("No record found", "Error");
        }
      }
      else {
        this.isloading = false;
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.isloading = false;
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  DownloadTracItUpdates() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportTracItUpdates';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportTracItUpdates.xls");
  }

}
